// src/context/AuthContext.js
import React, { createContext, useState, useEffect } from 'react';
import api from '../api/index.js';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(localStorage.getItem('token'));
    const [loading, setLoading] = useState(true);
    const [cashSession, setCashSession] = useState(null);
    const [isCashSessionOpen, setIsCashSessionOpen] = useState(false);

    // --- FUNCIÓN DE VERIFICACIÓN (NO CAMBIA, PERO SERÁ LLAMADA DE OTRA FORMA) ---
    const checkCashSessionStatus = async () => {
        if (!localStorage.getItem('token')) {
            setIsCashSessionOpen(false);
            setCashSession(null);
            return;
        }
        try {
            // Nota: Esta función todavía depende de /auth/me, así que si la llamamos
            // desde otro lado, el problema podría reaparecer.
            const response = await api.get('/auth/me');
            setUser(response.data);
            const sessionRes = await api.get('/cash-sessions/status');
            if (sessionRes.data.isOpen) {
                setCashSession(sessionRes.data.session);
                setIsCashSessionOpen(true);
            } else {
                setCashSession(null);
                setIsCashSessionOpen(false);
            }
        } catch (error) {
            console.error("Error en checkCashSessionStatus:", error);
            logout();
        }
    };

    // --- USEEFFECT MODIFICADO PARA LA PRUEBA ---
    useEffect(() => {
        console.log("AuthContext: Ejecutando useEffect de prueba (basado en localStorage)");
        
        // Desactivamos la lógica que llama a la API al cargar
        
        const loadUserAndSession = async () => {
            setLoading(true);
            await checkCashSessionStatus();
            setLoading(false);
        };
        loadUserAndSession();
        

        /* /// Reactivamos la lógica simple que solo lee de localStorage
        const storedToken = localStorage.getItem('token');
        const storedUser = localStorage.getItem('user');
        if (storedToken && storedUser) {
            console.log("AuthContext: Encontrado token y usuario en localStorage. Cargando estado.");
            setToken(storedToken);
            setUser(JSON.parse(storedUser));
        } else {
            console.log("AuthContext: No se encontró token/usuario en localStorage.");
        }
        // Aún necesitamos verificar la caja, pero lo hacemos después de cargar el usuario
        // para que PosPage pueda reaccionar.
        // Por ahora, para simplificar la prueba, lo comentamos.
        // checkCashSessionStatus(); 
        setLoading(false); */

    }, []);    // IMPORTANTE: El array de dependencias está VACÍO. Solo se ejecuta una vez.

    const login = async (email, password) => {
        try {
            const response = await api.post('/auth/login', { email, password });
            const { token, user } = response.data;
            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify(user));
            
            // Actualizamos el estado para que la app reaccione
            setToken(token);
            setUser(user);
            
            // Después del login, sí verificamos el estado de la caja.
            await checkCashSessionStatus();

            return true;
        } catch (error) {
            console.error("Error en login:", error);
            return false; // Retornar algo consistente en caso de error
        }
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setToken(null);
        setUser(null);
        setCashSession(null);
        setIsCashSessionOpen(false);
    };
    
    return (
        <AuthContext.Provider value={{ 
            user, token, login, logout, isAuthenticated: !!user, loading,
            isCashSessionOpen, cashSession, checkCashSessionStatus 
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;